import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import App from "./App";
import Login from "./Login";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
            <Routes path="/">
                <Route index element={<App />} />
                <Route path="login" element={<Login />} />
                <Route path='*' element={<>404</>} />
            </Routes>
        </BrowserRouter>
    </React.StrictMode>
);
